import React from 'react';
import CancelledDealReasonCell from './shared/CancelledDealReasonCell';
import { formatIndianCurrency } from '../../../../../shared/utils/CurrencyFormat';

const Section7 = ({
  mode,
  collapsedSections,
  renderSectionHeader,
  dsoData,
  allReasonsData,
  isLoadingReasons,
  handleOpenReasonModal,
  canAddReason,
  onSubmitReasonInline,
  isSubmittingReason,
  sectionNote
}) => {
  // Filter reasons for Cancelled Deal Reason topic
  const cancelledDealReasons = Array.isArray(allReasonsData)
    ? allReasonsData.filter((reason) => reason.topic === 'Cancelled Deal Reason')
    : [];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      {renderSectionHeader(7, 'Cancellations')}
      {(mode === 'view' || !collapsedSections[7]) && (
        <>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <div className="flex justify-between items-center">
              <span className="font-medium text-gray-900">Cancellation Rate</span>
              <span className="text-3xl font-bold text-red-600">
                {dsoData?.data?.cancelledClosedDealsPercentage?.current || 0}%
              </span>
            </div>
          </div>
          <div className="overflow-x-auto">
            {dsoData?.data?.cancelledClosedDeals?.length === 0 ? (
              <div className="flex justify-center items-center h-[8rem]">
                <p className="text-sm text-gray-500">No data available</p>
              </div>
            ) : (
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Customer
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      PLC
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Cost
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      GST
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Total
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Date
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-[40rem]">
                      Comment
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {dsoData?.data?.cancelledClosedDeals?.map((row, index) => (
                    <tr key={index}>
                      <td className="px-4 py-3 text-sm text-gray-900">{row?.lead?.user?.name}</td>
                      <td className="px-4 py-3 text-sm text-gray-900">
                        {formatIndianCurrency(row?.plc_price || 0)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900">
                        {formatIndianCurrency(row?.unit_price || 0)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900">
                        {formatIndianCurrency(row?.gst_price || 0)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900">
                        {formatIndianCurrency(row?.total_price || 0)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {row.closed_at
                          ? new Date(row.cancelledDate).toLocaleDateString('en-IN', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric'
                            })
                          : 'N/A'}
                      </td>
                      <CancelledDealReasonCell
                        row={row}
                        mode={mode}
                        handleOpenReasonModal={handleOpenReasonModal}
                        cancelledDealReasonsData={{ data: cancelledDealReasons }}
                        isLoadingCancelledDealReasons={isLoadingReasons}
                        canAddReason={canAddReason}
                        onSubmitReasonInline={onSubmitReasonInline}
                        isSubmittingReason={isSubmittingReason}
                      />
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
      {/* Section Note */}
      {sectionNote && (
        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-start gap-2">
            <svg
              className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h4 className="text-sm font-semibold text-gray-900">
                  {sectionNote.user?.vertical || 'Management'} notes
                </h4>
                <div className="inline-flex items-center gap-1 px-2 py-0.5 bg-gray-100 rounded-full">
                  <span className="text-xs text-gray-600">By</span>
                  <span className="text-xs font-medium text-gray-900">
                    {sectionNote.user?.name || 'Unknown User'}
                  </span>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{sectionNote.note}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Section7;
